import { useState, useCallback, ChangeEvent, useEffect, Fragment } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../stores';
import { setDetailField } from '../../stores/blackListList'; 
import { changeField, changeResult, selectBlackListAction, updateBlackListAction } from '../../stores/blackList';
import { ResponseFailModal, ResponseSuccessModal } from '../../components/Modal/Response';
import BlackDetail from '../../components/BlackList/BlackDetail';
import BlackDeleteContainer from './BlackDeleteContainer';
import { BlackDetailContainerProps } from '../../types/blackList';

const BlcakDetailContainer = ({
    isOpen,
    listBlack,
    handleViewChange
}:BlackDetailContainerProps) => {
    const dispatch = useDispatch();
    const { blackListItem, blackUpdateSuccess, blackUpdateError, detailField, userRole } = useSelector(({ blackList, blackListList, header }:RootState) => ({
        blackListItem: blackList.blackList,
        blackUpdateSuccess: blackList.blackUpdateSuccess,
        blackUpdateError: blackList.blackUpdateError,
        detailField: blackListList.detailField,
        userRole: header.userRole,
    }));
    
    const [ isOpenBlackListDeleteModal, setIsOpenBlackListDeleteModal ] = useState<boolean>(false);
    const [ isOpenBlackListUpdateSuccessModal, setIsOpenBlackListUpdateSuccessModal ] = useState<boolean>(false);
    const [ isOpenBlackListUpdateFailModal, setIsOpenBlackListUpdateFailModal ] = useState<boolean>(false);
    const [ isOpenRequiredParameterFailModal, setIsOpenRequiredParameterFailModal ] = useState<boolean>(false);
    const [ messageBlackListUpdateFail, setMessageBlackListUpdateFail ] = useState<string>('');

    const handleSelectBlackList = useCallback((targetId: string) => {
        if (targetId) {
            dispatch(selectBlackListAction({ id: targetId }));
        }
    }, [dispatch]);

    // 인풋 변경 이벤트 핸들러
    const handleChange = useCallback((e:ChangeEvent<HTMLInputElement>|ChangeEvent<HTMLSelectElement>) => {
        const { value, name } = e.target;
        dispatch(
            changeField({
                key: name,
                value: value,
            })
        );
    }, [dispatch]);

    const dateFormatter = (date:Date) => {
        return moment(date).format('YYYY-MM-DD HH:mm');
    };

    const handleBlackListDeleteModal = () => {
        setIsOpenBlackListDeleteModal(true);
    }

    const handleGoBack = () => {
        sessionStorage.removeItem('BLACK_LIST_DETAIL_ID'); // 세션 정리
        listBlack();
        handleViewChange('blackList', 'list');
        dispatch(
            changeResult({
                key: 'blackUpdateError',
                value: null,
            })
        );
    }

    const reload = () => {
        listBlack();
        handleViewChange('blackList', 'list');
    };

    const handleUpdateBlackList = useCallback(() => {
        if (!blackListItem.room_no || !blackListItem.room_type_code) {
            setIsOpenRequiredParameterFailModal(true); 
            return;
        }
        dispatch(updateBlackListAction({ ...blackListItem, id: detailField.id }));
    }, [detailField.id, blackListItem, dispatch]);

    useEffect(() => {
        if (blackUpdateError) {
            if (!blackUpdateError.response) {
                setMessageBlackListUpdateFail(blackUpdateError.message);
                setIsOpenBlackListUpdateFailModal(true);
            } else {
                if (blackUpdateError.response.data === undefined) {
                    setMessageBlackListUpdateFail(blackUpdateError.message);
                } else {
                    setMessageBlackListUpdateFail(`${blackUpdateError.response.data.code}, ${blackUpdateError.response.data.message}`);
                    if (blackUpdateError.response.data?.code === 401 || blackUpdateError.response.data?.code === 419) reload();
                }
                setIsOpenBlackListUpdateFailModal(true);
            }
        }
        if (blackUpdateSuccess) {
            setIsOpenBlackListUpdateSuccessModal(true);
            setTimeout(() => {
                setIsOpenBlackListUpdateSuccessModal(false);
                // 저장 성공 후 현재 ID로 다시 조회
                handleSelectBlackList(detailField.id); 
                dispatch(
                    changeResult({
                        key: 'blackUpdateSuccess',
                        value: false,
                    })
                );
            }, 1500);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [blackUpdateSuccess, blackUpdateError, handleSelectBlackList, dispatch]); // detailField.id 의존성 제거됨

    useEffect(() => {
        if (isOpen) {
            let currentId = detailField.id;

            if (!currentId) {
                currentId = sessionStorage.getItem('BLACK_LIST_DETAIL_ID') || '';
                
                if (currentId) {
                    dispatch(setDetailField(currentId));
                } else {
                    return; 
                }
            } else {
                sessionStorage.setItem('BLACK_LIST_DETAIL_ID', currentId);
            }
            handleSelectBlackList(currentId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, dispatch, handleSelectBlackList]); 

    return (
        <Fragment>
            <BlackDetail
                blackListItem={blackListItem}
                userRole={userRole}
                dateFormatter={dateFormatter}
                handleChange={handleChange}
                handleUpdateBlackList={handleUpdateBlackList}
                handleBlackListDeleteModal={handleBlackListDeleteModal}
                handleGoBack={handleGoBack} 
            />
            <BlackDeleteContainer
                isOpen={isOpenBlackListDeleteModal}
                toggle={() => setIsOpenBlackListDeleteModal(!isOpenBlackListDeleteModal)}
                reload={reload}
                id={detailField.id}
                blackListName={blackListItem.room_no} 
            />
            <ResponseSuccessModal
                isOpen={isOpenBlackListUpdateSuccessModal}
                toggle={() => setIsOpenBlackListUpdateSuccessModal(!isOpenBlackListUpdateSuccessModal)}
                message='객실 정보 수정이 완료 되었습니다.' 
            />
            <ResponseFailModal
                isOpen={isOpenBlackListUpdateFailModal}
                toggle={() => setIsOpenBlackListUpdateFailModal(!isOpenBlackListUpdateFailModal)}
                message={messageBlackListUpdateFail || '객실 정보 수정에 실패 하였습니다.'} 
            />
            <ResponseFailModal
                isOpen={isOpenRequiredParameterFailModal}
                toggle={() => setIsOpenRequiredParameterFailModal(!isOpenRequiredParameterFailModal)}
                message='필수 입력값을 확인 해주세요.'
            />
        </Fragment>
    );
};

export default BlcakDetailContainer;